import { ChevronLeft } from "@mui/icons-material"
import { IconButton, Typography } from "@mui/material"

const ButtonReturn = ({text = 'Voltar'}) => {

    const styledButton = {
        position: 'relative',
        display: 'inline-block',
        padding: '.5rem 1rem',
        textDecoration: 'none',
        fontWeight: 600,
        transition: '0.3s',
        border: '2px solid transparent',
        borderRadius: '10px',
        '&:hover': {
            border: '2px solid #A6A6A6',
        },
    };


    return (
        <IconButton 
            onClick={() => window.history.back()} 
            sx={styledButton}
        >    
            <Typography
                variant="body1"
                sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    color: '#A6A6A6',
                    fontSize: '1rem'
                }}
            >
                <ChevronLeft />{text}
            </Typography>
        </IconButton>
    )
}

export default ButtonReturn
